import { injectGlobal } from 'styled-components' // TODO: Refactor to createGlobalStyle https://www.styled-components.com/docs/api#createglobalstyle with styled component v4

injectGlobal`
* {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

html,body,div,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,ol,ul,li,form,legend,label,table,header,footer,nav,section,figure,button,main {
    margin: 0;
    padding: 0
}

header,footer,nav,section,article,hgroup,figure,main {
    display: block
}

.is-hidden {
    display: none !important;
    visibility: hidden !important
}

.is-vishidden {
    position: absolute !important;
    overflow: hidden;
    width: 1px;
    height: 1px;
    padding: 0;
    border: 0;
    clip: rect(1px, 1px, 1px, 1px)
}

.is-disabled {
    opacity: 0.4;
    pointer-events: none;
    cursor: default
}

body {
    font: 14px/1.4 "Arial",sans-serif;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    color: #333;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}

@media print {
    body {
        color: #000;
        background: #fff
    }
}

a {
    color: #007aff;
    text-decoration: none;
    outline: 0;
    cursor: pointer;
    background: transparent
}

a:hover,a:focus {
    color: #049;
}

p {
    margin-bottom: 1em
}

mark {
    background: #ffe96e
}

sup {
    font-size: 0.6em;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
    top: -0.5em
}

.footnote {
    font-size: 12px;
    line-height: 1.3em
}

b,strong {
    font-weight: bold
}

img {
    border: 0
}

hr {
    border: 0;
    height: 1px;
    background: #f2f2f2;
    margin: 2em 0
}

ol,ul {
    list-style: none
}

h1,h2,h3,h4 {
    font-weight: normal;
    line-height: 1.2
}

h1 {
    font-size: 36px
}

h2 {
    font-size: 26px
}

h3 {
    font-size: 18px
}

h4 {
    font-size: 18px
}

table {
    border-collapse: collapse;
    border-spacing: 0
}

input[type="submit"].button--primary,.button--primary,.button--primary--large,input[type="submit"].button--secondary,.button--secondary,.button--secondary--inverted,.button--cancel {
    padding: 10px 16px 11px;
    border: 0 none;
    outline: none;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    border-radius: 3px;
    -moz-transition: all 0.12s ease-in-out;
    -o-transition: all 0.12s ease-in-out;
    -webkit-transition: all 0.12s ease-in-out;
    transition: all 0.12s ease-in-out;
    display: inline-block;
    vertical-align: middle;
    *vertical-align: auto;
    *zoom:1;*display: inline;
    font-weight: normal;
    font-size: 16px;
    position: relative;
    line-height: 1.1;
    font-family: inherit;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}

@media only screen and (max-width: 767px) {
    .touch input[type="submit"].button--primary,.touch .button--primary,.touch .button--primary--large,.touch input[type="submit"].button--secondary,.touch .button--secondary,.touch .button--secondary--inverted,.touch .button--cancel {
        width:100%
    }
}

input[type="submit"].button--primary:hover,.button--primary:hover,.button--primary--large:hover,input[type="submit"].button--secondary:hover,.button--secondary:hover,.button--secondary--inverted:hover,.button--cancel:hover {
    color: #fff
}

input[type="submit"].button--primary i,.button--primary i,.button--primary--large i,input[type="submit"].button--secondary i,.button--secondary i,.button--secondary--inverted i,.button--cancel i {
    display: inline-block;
    vertical-align: middle;
    *vertical-align: auto;
    *zoom:1;*display: inline;
    position: absolute
}

input[type="submit"].button--primary,.button--primary,.button--primary--large {
    background: #47a216;
    color: #fff
}

input[type="submit"].button--primary:hover,.button--primary:hover,.button--primary--large:hover {
    background: #3c910e
}

input[type="submit"].button--secondary,.button--secondary {
    background: #0a84c1;
    color: #fff
}

input[type="submit"].button--secondary:hover,.button--secondary:hover {
    background: #085397
}

.button--secondary--inverted {
    background: #fff;
    color: #0a84c1
}

.button--secondary--inverted:hover {
    color: #085397
}

.button--cancel {
    background: #fff;
    color: #b01408
}

.button--cancel:hover {
    color: #981107
}

.button--primary--large {
    font-size: 20px
}

label {
    display: block;
    padding-bottom: 0.18em;
    color: #333;
    cursor: pointer
}

input[type="email"],input[type="password"],input[type="tel"],input[type="number"],input[type="search"],input[type="search"]::-webkit-search-cancel-button,input[type="search"]::-webkit-search-decoration,input[type="submit"],input[type="url"],textarea {
    -webkit-appearance: none;
    -moz-border-radius: 0;
    -webkit-border-radius: 0;
    border-radius: 0
}

input[type="email"],input[type="password"],input[type="tel"],input[type="number"],input[type="search"],input[type="url"],textarea {
    outline: 0;
    background: #fff;
    color: #333;
    -moz-transition: all 0.15s ease-in-out;
    -o-transition: all 0.15s ease-in-out;
    -webkit-transition: all 0.15s ease-in-out;
    transition: all 0.15s ease-in-out;
    border: 1px solid #ccc;
    cursor: text;
    -moz-box-shadow: #d9d9d9 0 1px 2px inset;
    -webkit-box-shadow: #d9d9d9 0 1px 2px inset;
    box-shadow: #d9d9d9 0 1px 2px inset
}

input[type="email"]:focus,input[type="password"]:focus,input[type="tel"]:focus,input[type="number"]:focus,input[type="search"]:focus,input[type="url"]:focus,textarea:focus {
    border-color: #0a84c1;
    -moz-box-shadow: #cae4f2 0 0 5px;
    -webkit-box-shadow: #cae4f2 0 0 5px;
    box-shadow: #cae4f2 0 0 5px
}

input[type="email"],input[type="password"],input[type="tel"],input[type="number"],input[type="search"],input[type="url"],textarea {
    width: 100%
}

input,select,textarea,.select-container,.select-container--width {
    font-family: inherit;
    font-size: 100%;
    margin: 0 1px 0
}

textarea,input {
    padding: 0.5em 0.65em 0.6em 0.65em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale
}

input[type="checkbox"],input[type="radio"] {
    width: auto;
    margin-right: 0.3em;
    cursor: pointer
}

.input-container--width,.input-container--calendar--width,.input-container--search--width,.select-container--width {
    width: 170px
}

.field-container {
    margin-bottom: 1em
}

.field-container.has-error label {
    color: #b01408
}

.field-container.has-error input,.field-container.has-error .select-container,.field-container.has-error .select-container--width {
    border-color: #b01408
}

.field-container.has-error textarea {
    border-color: #b01408
}

.input-container--calendar,.input-container--calendar--width,.input-container--search,.input-container--search--width {
    position: relative
}

.input-container--calendar input,.input-container--calendar--width input,.input-container--search input,.input-container--search--width input {
    padding: 0.5em 2em 0.6em 0.65em
}

.input-container--calendar .icon-utility-calendar,.input-container--calendar--width .icon-utility-calendar,.input-container--search .icon-utility-search,.input-container--search--width .icon-utility-search {
    position: absolute;
    color: #0a84c1;
    right: 0.57em
}

.input-container--calendar .icon-utility-calendar,.input-container--calendar--width .icon-utility-calendar {
    top: 0.65em
}

.input-container--search .icon-utility-search,.input-container--search--width .icon-utility-search {
    top: 0.7em
}

.select-container,.select-container--width {
    border: 1px solid #d9d9d9;
    overflow: hidden;
    background-color: #fff;
    position: relative
}

.select-container__arrow,.select-container--width__arrow {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border: inset 5px;
    border-color: #0a84c1 transparent transparent transparent;
    border-top-style: solid;
    color: #0a84c1;
    position: absolute;
    right: 0.57em;
    top: 0.95em;
    pointer-events: none;
    display: none\0
}

.select-container__select,.select-container--width__select {
    padding: 0.5em 2em 0.6em 0.65em;
    padding-right: 0.65em\0;
    width: 100%;
    border: none;
    box-shadow: none;
    background-color: transparent;
    background-image: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: #333;
    cursor: pointer
}

.select-container__select:focus,.select-container--width__select:focus {
    outline: none
}

@-moz-document url-prefix() {
    .select-container select {
        width: 110%
    }

    .select-container--width select {
        width: 110%
    }
}

.credit-card-image--amex,.credit-card-image--mastercard,.credit-card-image--paypal,.credit-card-image--visa,.credit-card-image--discover,.credit-card-image--google {
    height: 24px;
    width: 38px;
    display: block;
    background: url("http://mobileimg.priceline.com/pink/credit-card-image.png") no-repeat
}

@media (min--moz-device-pixel-ratio: 1.3), (-o-min-device-pixel-ratio: 2.6 / 2), (-webkit-min-device-pixel-ratio: 1.3), (min-device-pixel-ratio: 1.3), (min-resolution: 1.3dppx) {
    .credit-card-image--amex,.credit-card-image--mastercard,.credit-card-image--paypal,.credit-card-image--visa,.credit-card-image--discover,.credit-card-image--google {
        background-image:url("http://mobileimg.priceline.com/pink/credit-card-image@2x.png");
        background-size: 38px 152px
    }
}

.credit-card-image--mastercard {
    background-position: 0 -25px
}

.credit-card-image--paypal {
    background-position: 0 -50px
}

.credit-card-image--visa {
    background-position: 0 -75px
}

.credit-card-image--discover {
    background-position: 0 -100px
}

.credit-card-image--google {
    background-position: 0 -125px
}

.layout-one-col,.layout-two-col-results,.layout-two-col-sidebar,.layout-three-col-results,.layout-three-col-map {
    padding: 0 20px;
    min-width: 1200px
}

.layout-one-col>*,.layout-two-col-results>*,.layout-two-col-sidebar>*,.layout-three-col-results>*,.layout-three-col-map>* {
    width: 1160px;
    margin: 0 auto;
    overflow: hidden
}

.layout-one-col>*:after,.layout-two-col-results>*:after,.layout-two-col-sidebar>*:after,.layout-three-col-results>*:after,.layout-three-col-map>*:after {
    content: "";
    display: table;
    clear: both
}

.layout-two-col-results>*>[role="navigation"] {
    width: 210px;
    float: left
}

.layout-two-col-results>*>[role="main"] {
    width: 930px;
    float: right;
    margin-left: 20px
}

.layout-two-col-sidebar>*>[role="main"] {
    float: left;
    margin-right: 20px;
    width: 840px
}

.layout-two-col-sidebar>*>[role="complementary"] {
    width: 300px;
    float: right
}

.layout-three-col-results>*>[role="navigation"] {
    width: 210px;
    float: left
}

.layout-three-col-results>*>[role="main"] {
    float: left;
    margin: 0 20px;
    width: 610px
}

.layout-three-col-results>*>[role="complementary"] {
    width: 300px;
    float: right
}

.layout-three-col-map>*>[role="navigation"] {
    width: 210px;
    float: left
}

.layout-three-col-map>*>[role="main"] {
    float: left;
    margin: 0 20px;
    width: 300px
}

.layout-three-col-map>*>[role="complementary"] {
    width: 610px;
    float: right
}

.alert-success,.alert-info,.alert-danger {
    padding: 10px 20px;
    display: inline-block;
    vertical-align: middle;
    *vertical-align: auto;
    *zoom:1;*display: inline;
    width: 100%
}

.alert-success {
    background: #ebfae4;
    color: #3c910e
}

.alert-info {
    background: #ffe96e;
    color: #333
}

.alert-danger {
    background: #fedfe1;
    color: #b01408
}

.breadcrumbs__item {
    display: inline-block
}

.breadcrumbs__item+.breadcrumbs__item:before {
    padding: 0 9px;
    content: "/ ";
    color: #999
}

.breadcrumbs__link {
    display: inline-block
}

.breadcrumbs .is-active {
    color: #333;
    cursor: default;
    pointer-events: none
}

.pagination i {
    font-size: 10px
}

.pagination .is-active {
    color: #333;
    cursor: default;
    pointer-events: none
}

.pagination__item {
    display: inline-block;
    vertical-align: middle;
    *vertical-align: auto;
    *zoom:1;*display: inline
}

.pagination__link,.pagination__link--prev,.pagination__link--next {
    padding-top: 10px;
    padding-bottom: 10px
}

.pagination__link {
    padding-left: 12px;
    padding-right: 12px
}

.pagination__link--prev {
    padding-right: 10px
}

.pagination__link--prev i {
    padding-right: 10px
}

.pagination__link--next {
    padding-left: 10px
}

.pagination__link--next i {
    padding-left: 10px
}

.tabs-secondary__list {
    display: table;
    width: auto;
    z-index: 1
}

.tabs-secondary__item {
    display: table-cell;
    text-align: center;
    margin-right: 5px;
    vertical-align: bottom;
    position: relative;
    padding: 8px 20px;
    color: #0a84c1;
    background: #fff;
    cursor: pointer;
    border: 1px solid #fff;
    border-bottom: 0 none
}

.tabs-secondary__item:hover {
    color: #085397
}

.tabs-secondary__item.is-active {
    border: 1px solid #d9d9d9;
    border-bottom: 0 none;
    cursor: default;
    color: #333;
    position: relative
}

.tabs-secondary__item.is-active:after {
    position: absolute;
    content: "";
    display: block;
    height: 1px;
    background-color: #fff;
    bottom: -1px;
    left: 0;
    right: 0
}

.tabs-secondary__content-container {
    border-top: 1px solid #d9d9d9
}

div[id^='end'][id$='-dropdown'] {
  right: 0;
}

div[id^='flight-arrival'][id$='dropdown'] {
  right: 0;
}
`
